import React, { useEffect, useState } from 'react';
import './styles.scss';

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 400) setVisible(true); else setVisible(false);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    try { sessionStorage.removeItem('landingScrollTarget'); } catch(e) {}
    // No manipular el historial principal, solo hacer scroll
    // Si quieres navegar a la landing, usa navegación interna
    // navigate('/'); // Si quieres que el botón también navegue
  };

  return (
    <div className={`back-to-top-btn ${visible ? 'show' : ''}`}> 
      <button
        aria-label="Volver al inicio"
        className="btn-icon btn-red rounded-shell back-to-top-btn-style text-uppercase text-white shell-bold"
        onClick={scrollTop}
      >
        <span>Ir al inicio</span>
        <svg className="arrow-svg" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 4L11 18" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M5 10L11 4L17 10" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button>
    </div>
  );
};

export default BackToTopButton;
